// extracted by mini-css-extract-plugin
export default {"statusIcon":"_3WUsp3Nr21MawC04FM2coA==","dnd":"Z+FtS8egG66xujpIoFpFLA==","online":"c3NxzQjmhe51IV3wQdJJtA==","away":"_7fHmsQjE1VaVBEWo3zcwrg==","offline":"g2U53gqxJ+YEipenp0S2RQ=="};